import { render, staticRenderFns } from "./CustomJsonContent.vue?vue&type=template&id=187dea9c&scoped=true&"
import script from "./CustomJsonContent.vue?vue&type=script&lang=js&"
export * from "./CustomJsonContent.vue?vue&type=script&lang=js&"
import style0 from "./CustomJsonContent.vue?vue&type=style&index=0&id=187dea9c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "187dea9c",
  null
  
)

export default component.exports